import { Font16 } from 'components/Typography/Labels'
import { Font14 } from 'components/Typography/Labels'
import { WhiteBlock } from 'components/Layout'
import styled from 'styled-components'
import { CommonLinkButton } from 'components/Button'
import Icon from '@mdi/react'
import theme from 'theme_'

export const DeleteClaimDeviceButton = styled(CommonLinkButton)`
  padding: 0;
`

export const DeleteClaimDeviceButtonIcon = styled(Icon)`
  color: ${theme.colors.horizonOrange};
`

export const MobileClaimDeviceWrapper = styled(WhiteBlock)`
  width: 100%;
  gap: 28px;
  margin-top: -16px;
`

export const MobileClaimDeviceHeader = styled.div`
  display: flex;
  justify-content: space-between;
`

export const ClaimDeviceTableImage = styled.img`
  width: 23px;
  height: 23px;
  margin-right: 10px;
`

export const MobileClaimDeviceHeaderTitle = styled.div`
  ${Font14};
  font-weight: 600;
  display: flex;
  align-items: center;
`

export const ClaimDeviceTableTitle = styled.div`
  ${Font16};
  font-weight: 600;
`
